import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-auction-ended',
  templateUrl: './modal-auction-ended.component.html',
  styleUrls: ['./modal-auction-ended.component.scss']
})
export class ModalAuctionEndedComponent {
  constructor (public activeModal: NgbActiveModal) {}
}
